import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { GENERIC_CATEGORY_LIST_TRANSLATE_BASE } from "@shared/constants/stored-documents.constants";
import { StoredDocumentCategory } from "@shared/models/stored-document-category.model";
import { ButtonModule } from "primeng/button";
import { DropdownModule } from "primeng/dropdown";
@Component({
  selector: "app-stored-documents-list-category-filter",
  standalone: true,
  imports: [ButtonModule, CommonModule, FormsModule, DropdownModule, TranslateModule],
  templateUrl: "./stored-documents-list-category-filter.component.html",
  styleUrl: "./stored-documents-list-category-filter.component.scss",
})
export class StoredDocumentsListCategoryFilterComponent {
  @Input() categories: StoredDocumentCategory[] | undefined;
  @Input() selectedCategory: StoredDocumentCategory | undefined;
  @Output() selectedCategoryChange = new EventEmitter<StoredDocumentCategory | undefined>();
  @Output() sendEditCategoryEvent = new EventEmitter<boolean>();
  valueChange() {
    this.selectedCategoryChange.emit(this.selectedCategory);
  }

  getGenericCategoryTranslationUri(id: string) {
    return GENERIC_CATEGORY_LIST_TRANSLATE_BASE + id;
  }

  editList() {
    this.sendEditCategoryEvent.emit(true);
  }
}
